var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('integration-config-tabs',{attrs:{"title-integration-data":'Datos para LinioMx',"ic":_vm.ic,"tempView":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }